<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>需給契約検索</h1>

<!-- Select what to search -->
<mat-expansion-panel class="mat-expansion-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title class="title">検索条件</mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <form [formGroup]="kensakuJyoukenForm">
      <!-- 検索条件コンポーネント -->
      <app-sgkb713d-search-condition (onClickButtonEvent)="setValue($event)"
        [mode]="mode">
      </app-sgkb713d-search-condition>
    </form>
  </div>
</mat-expansion-panel>

<div *ngIf="showResult && !clearExeFlg">
  <mat-card class="cur-card">
    <!-- 検索結果コンポーネント -->
    <app-sgkb713d-search-result (rowClickEvent)="onClickRow($event)"
      [mode]="mode" [ctrSearchresultList]="ctrSearchresultList">
    </app-sgkb713d-search-result>
  </mat-card>
</div>
